function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import cn from 'classnames';
import { Card, FullBox, Collapse } from 'seagull';
import { WideArrowDownward, SyncLiner24, DangerLiner24 } from 'seagull/icons';
import { useIoContext } from "../../../../contexts";
import CheckmarkCircle from "./CheckmarkIcon.json";
import styles from "./StepItemsList.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StepItem = /*#__PURE__*/React.memo(function StepItem(_ref) {
  let {
    title,
    content,
    status,
    isExpanded,
    onExpand,
    onComplete: _onComplete
  } = _ref;
  const {
    Lottie
  } = useIoContext();
  const [hasPlayedCompleted, setHasPlayedCompleted] = useState(status === 'completed');
  useEffect(() => {
    if (status !== 'completed') setHasPlayedCompleted(false);
  }, [status]);
  const shouldAutoplay = status === 'completed' && !hasPlayedCompleted;
  const statusIcon = useMemo(() => {
    if (status === 'pending') return /*#__PURE__*/_jsx(SyncLiner24, {});
    if (status === 'error') return /*#__PURE__*/_jsx(DangerLiner24, {});
    return /*#__PURE__*/_jsx(Lottie, {
      animationData: CheckmarkCircle,
      loop: false,
      autoplay: shouldAutoplay,
      initialSegment: status === 'initial' ? [0, 0] : hasPlayedCompleted ? [24, 24] : undefined,
      onComplete: () => {
        setHasPlayedCompleted(true);
        if (isExpanded) {
          _onComplete();
        }
      },
      style: {
        width: 22,
        height: 22
      }
    }, status);
  }, [status, shouldAutoplay, hasPlayedCompleted, isExpanded, _onComplete]);
  return /*#__PURE__*/_jsxs(Card, {
    className: styles.stepItemContainer,
    children: [/*#__PURE__*/_jsxs("button", {
      className: styles.stepItemHeader,
      onClick: onExpand,
      disabled: !content,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.stepStatusIcon,
        children: statusIcon
      }), /*#__PURE__*/_jsx("span", {
        className: styles.stepItemTitle,
        children: title
      }), content && /*#__PURE__*/_jsx("div", {
        className: cn(styles.arrowContainer, {
          [styles.reverseArrow]: isExpanded
        }),
        children: /*#__PURE__*/_jsx(WideArrowDownward, {})
      })]
    }), content && /*#__PURE__*/_jsx(Collapse, {
      in: isExpanded,
      collapsedSize: 0,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.stepItemContent,
        children: content
      })
    })]
  });
});
export default function StepItemsList(_ref2) {
  let {
    steps
  } = _ref2;
  const [expandedItem, setExpandedItem] = useState();
  const toggleExpandedItem = useCallback(index => {
    setExpandedItem(prev => prev === index ? undefined : index);
  }, []);
  const handleComplete = useCallback(() => {
    setExpandedItem(steps.findIndex(step => step.status !== 'completed'));
  }, [setExpandedItem, steps]);
  return /*#__PURE__*/_jsx(FullBox, {
    flexDirection: "column",
    className: styles.allStepsContainer,
    children: steps.map((item, index) => /*#__PURE__*/_jsx(StepItem, _objectSpread(_objectSpread({}, item), {}, {
      isExpanded: expandedItem === index,
      onExpand: () => toggleExpandedItem(index),
      onComplete: handleComplete
    }), "stepItem-".concat(index)))
  });
}